function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var POST_GROUPMEMBERS_REQUEST = "POST_GROUPMEMBERS_REQUEST";
export var POST_GROUPMEMBERS_SUCCESS = "POST_GROUPMEMBERS_SUCCESS";
export var POST_GROUPMEMBERS_FAILURE = "POST_GROUPMEMBERS_FAILURE";
export var RESET_POST_GROUPMEMBERS = "RESET_POST_GROUPMEMBERS";
export var postGroupMembers = function postGroupMembers(groupMembers) {
  return _defineProperty({
    groupMembers: groupMembers
  }, CALL_API, {
    types: [POST_GROUPMEMBERS_REQUEST, POST_GROUPMEMBERS_SUCCESS, POST_GROUPMEMBERS_FAILURE],
    endpoint: "groupMembers",
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(groupMembers),
      credentials: "same-origin"
    }
  });
};
export var resetPostGroupMembers = function resetPostGroupMembers() {
  return {
    type: RESET_POST_GROUPMEMBERS
  };
};
export var POST_GROUPMEMBER_REQUEST = "POST_GROUPMEMBER_REQUEST";
export var POST_GROUPMEMBER_SUCCESS = "POST_GROUPMEMBER_SUCCESS";
export var POST_GROUPMEMBER_FAILURE = "POST_GROUPMEMBER_FAILURE";
export var RESET_POST_GROUPMEMBER = "RESET_POST_GROUPMEMBER";
export var postGroupMember = function postGroupMember(groupMember) {
  return _defineProperty({
    groupMember: groupMember
  }, CALL_API, {
    types: [POST_GROUPMEMBER_REQUEST, POST_GROUPMEMBER_SUCCESS, POST_GROUPMEMBER_FAILURE],
    endpoint: "groupMembers/".concat(member.id),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(member),
      credentials: "same-origin"
    }
  });
};
export var resetPostGroupMember = function resetPostGroupMember() {
  return {
    type: RESET_POST_GROUPMEMBER
  };
};
export var DELETE_GROUPMEMBER_REQUEST = "DELETE_GROUPMEMBER_REQUEST";
export var DELETE_GROUPMEMBER_SUCCESS = "DELETE_GROUPMEMBER_SUCCESS";
export var DELETE_GROUPMEMBER_FAILURE = "DELETE_GROUPMEMBER_FAILURE";
export var RESET_DELETE_GROUPMEMBER = "RESET_DELETE_GROUPMEMBER";
export var deleteGroupMember = function deleteGroupMember(groupMember) {
  return _defineProperty({
    groupMember: groupMember
  }, CALL_API, {
    types: [DELETE_GROUPMEMBER_REQUEST, DELETE_GROUPMEMBER_SUCCESS, DELETE_GROUPMEMBER_FAILURE],
    endpoint: "groupMembers/".concat(groupMember.id),
    init: {
      method: "DELETE",
      credentials: "same-origin"
    }
  });
};
export var resetDeleteGroupMember = function resetDeleteGroupMember() {
  return {
    type: RESET_DELETE_GROUPMEMBER
  };
};